import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'termsofservice',
  templateUrl: './termsofservice.component.html'
})
export class TermsOfServiceComponent {

  constructor(
    public userService: UserService
  ) {
  
  }

  agree() {
    this.userService.accept = true;
  }

  disagree() {
    window.location.href = "/";
  }
  

}
